module.exports = __webpack_public_path__ + "67a848bf363c3651151993419cb19034.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/social/pinterest-c.png
// module id = 1460
// module chunks = 0